import moment from 'moment';
import { format, subDays } from 'date-fns';

// import { luftGet, luftPost, luftDelete, luftDownload } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

import { USER_TYPES } from '../pages/Admin/shared/static-options';

import DynamicAPI from '../shared/axios';

// region ACTIONS
// actions

const CHANGE_FILTERS = 'luft/note-connection/CHANGE_FILTERS';
const FILTERS_CLEAR = 'luft/note-connection/FILTERS_CLEAR';

const GET_NOTE_LIST = 'luft/note-connection/GET_NOTE_LIST';
const GET_NOTE_LIST_SUCCESS = 'luft/note-connection/GET_NOTE_LIST_SUCCESS';
const GET_NOTE_LIST_FAILURE = 'luft/note-connection/GET_NOTE_LIST_FAILURE';

const VIEW_NOTE_DETAILS = 'luft/note-connection/VIEW_NOTE_DETAILS';

const CHANGE_SEARCH_FIELD_IS_IN_USE =
  'luft/note-connection/CHANGE_SEARCH_FIELD_IS_IN_USE';

// endregion

// region INITIAL STATE + REDUCER
// reducer

const filtersInitialState = {
  query: '',
  initialPeriod: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
  finalPeriod: format(new Date(), 'yyyy-MM-dd'),
  status: null,
  currentPage: 1,
  pageLimit: 10,
  sort: 0
};

const initialState = {
  filters: {
    ...filtersInitialState,
  },
  noteList: {
    isFetching: false,
    error: '',
    requested: '',
    data: {
      list: [],
      totalItems: 0,
    },
  },
  searchFieldIsInUse: false,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SEARCH_FIELD_IS_IN_USE:
      return {
        ...state,
        searchFieldIsInUse: action.searchFieldIsInUse,
      };

    // filters
    case CHANGE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };

    case FILTERS_CLEAR:
      return {
        ...state,
        filters: {
          ...filtersInitialState,
        },
      };

    // Note list

    case GET_NOTE_LIST:
      return {
        ...state,
        noteList: {
          ...state.noteList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_NOTE_LIST_SUCCESS: {
      const { list } = action;
      return {
        ...state,
        noteList: {
          ...state.noteList,
          isFetching: false,
          error: '',
          data: {
            list: list.data.invoiceNfeGetDTO,
            totalItems: list.data.invoiceQuantity ,
          },
        },
      };
    }

    case GET_NOTE_LIST_FAILURE:
      return {
        ...state,
        noteList: {
          ...state.noteList,
          isFetching: false,
          error: action.error,
        },
      };

    case VIEW_NOTE_DETAILS:
      return {
        ...state,
        currentNoteDetailsId: action.id,
      };

    // Default
    default:
      return state;
  }
}

export default reducer;

export function changeSearchFieldIsInUse(searchFieldIsInUse = false) {
  return {
    type: CHANGE_SEARCH_FIELD_IS_IN_USE,
    searchFieldIsInUse,
  };
}

// endregion

// region ACTION CREATORS
// actions creators

// filters

export function changeFilters(filters = {}) {
  return {
    type: CHANGE_FILTERS,
    filters,
  };
}

export function filtersClear() {
  return {
    type: FILTERS_CLEAR,
  };
}

// NF list

function _getNoteList() {
  return {
    type: GET_NOTE_LIST,
  };
}

function _getNoteListSuccess(list) {
  return {
    type: GET_NOTE_LIST_SUCCESS,
    list,
  };
}

function _getNoteListFailure(error) {
  return {
    type: GET_NOTE_LIST_FAILURE,
    error,
  };
}

// NF Details

export function viewNoteDetails(id) {
  return {
    type: VIEW_NOTE_DETAILS,
    id,
  };
}

// endregion

// region THUNKS
// thunk action creators

export function _buildFiltersParams(filters) {
  // extract filter params from state
  const {
    query,
    initialPeriod,
    finalPeriod,
    status,
    currentPage,
    pageLimit,
    sort,
  } = filters;

  const hasDocument = query && query.trim() !== '';

  return {
      Document: query || '',
      
      ...(hasDocument ? {} : {
        InitialDate: initialPeriod || '',
        FinalDate: finalPeriod || '',
      }),
      ...(status && { Status: status }),
      Sort: sort || 0,
      Page: currentPage || 1,
      QuantityPerPage: pageLimit || 10,
  };
}


export function getNoteList() {
  return function (dispatch, getState) {
    
    (async () => {
      dispatch(_getNoteList());
      try {
        const params = _buildFiltersParams(getState().notesConnection.filters);
        const { userType, activeCompanyId } = getState().auth;
        const http = new DynamicAPI('v1');

        console.log({ userType, activeCompanyId }, USER_TYPES)

        const statusString = params?.Status?.map(s => `Status=${s}`).join("&");

        // eslint-disable-next-line no-unused-vars
        const { Status, ...restParams } = params;

        const response = await http.get(
          `/InvoiceNfe/Get${statusString ? `?${statusString}` : ''}`,
          {
            ...restParams,
            ...(userType === USER_TYPES.CUSTOMER_SERVICE_USER &&
            {
              companyId: activeCompanyId
            }
            )
          },
        );

        dispatch(_getNoteListSuccess(response));

      } catch (error) {
        console.log({error});
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getNoteListFailure('Ops! Parece que tivemos um erro interno. Tente novamente mais tarde.'),
        );
      }
    })();
  };
}

// endregion
